import React from 'react';
import Navigation from '../components/Navigation';
import Sponsors from '../components/Sponsors';
import Footer from '../components/Footer';
import ProgramRegulationPopup from '../components/ProgramRegulationPopup';

const Program = () => {
    return (
        <div className="section-program">
            <ProgramRegulationPopup />
            <Navigation />
            <div className="container-title">
                <h2>Programme</h2>
            </div>
            <a
                href="../assets/documents/v2-reglement trail muco.pdf"
                target="_blank"
                download="v2-reglement trail muco.pdf"
            >
                <button className="btn-race">Télécharger le règlement</button>
            </a>
            <div className="first-container header-program">
                <div className="maj">
                    <h3>Vendredi 2 octobre 2026 au soir</h3>
                </div>
                <section className="container-section program nocturne">
                    <div className="children-left">
                        <img
                            className="children-picture"
                            src="../assets/img/nocturne.jpg"
                            alt="course nocturne lors du trail-muco"
                        />
                    </div>
                    <div className="children-right">
                        <h2>Les Cap'Tambules</h2>
                        <strong>
                            Départ centre bourg de La Chapelle Erbrée.
                        </strong>
                        <br />
                        <ul className="nocturne-list">
                            <li className="custom-li">
                                <em>
                                    <i className="fa-solid fa-flag-checkered first "></i>{' '}
                                    Départs à 20h00{' '}
                                    <i className="fa-solid fa-flag-checkered last"></i>
                                </em>
                                12 km (12€)
                                <a
                                    href="../assets/img/parcours/Trail Muco cap'tambule 12Km 2026.pdf"
                                    target="_blank"
                                    download="Trail Muco cap'tambule 12Km 2026.pdf"
                                >
                                    <button className="btn-race">
                                        Télécharger le tracé
                                    </button>
                                </a>
                            </li>
                            <li className="custom-li">
                                <em>
                                    <i className="fa-solid fa-flag-checkered first "></i>{' '}
                                    Départs à 20h15{' '}
                                    <i className="fa-solid fa-flag-checkered last"></i>
                                </em>
                                5 km (10€)
                                <a
                                    href="../assets/img/parcours/Trail Muco petite cap'tambule 5Km 2026.pdf"
                                    target="_blank"
                                    download="Trail Muco petite cap'tambule 5Km 2026.pdf"
                                >
                                    <button className="btn-race">
                                        Télécharger le tracé
                                    </button>
                                </a>
                            </li>
                        </ul>
                        <em>
                            * Attestation Parcours Prévention Santé obligatoire.
                            <br></br>
                            Voir article 4 du règlement.
                        </em>

                        <div className="warning">
                            <div className="wild">
                                <i className="fa-solid fa-triangle-exclamation custom"></i>
                                <p>Pas de gobelets aux ravitaillements</p>
                                <i className="fa-solid fa-triangle-exclamation custom"></i>
                            </div>
                            <p>Prévoir vos écotasses.</p>
                        </div>
                    </div>
                </section>

                <h3> Samedi 3 octobre 2026 </h3>

                <section className="container-section program">
                    <div
                        className="children-left"
                        data-aos="fade-right"
                        data-aos-offset="200"
                    >
                        <img
                            className="children-picture"
                            src="../assets/img/marche-nordique.jpg"
                            alt="marche nordique lors du trail-muco"
                        />
                    </div>
                    <div
                        className="children-right"
                        data-aos="fade-left"
                        data-aos-offset="200"
                    >
                        <h2>Marches Nordiques de l'Aurore</h2>
                        <strong>
                            Départ de la base de loisirs de Haute Vilaine - à St
                            M'Hervé (35)
                        </strong>
                        <br />
                        <ul className="nocturne-list">
                            <li className="custom-li nordique">
                                Le Delanchy, 18km chronométrée (14€) <br />
                                <span>
                                    <i className="fa-solid fa-flag-checkered first"></i>
                                    Challenge Nordique Bretagne
                                    <i className="fa-solid fa-flag-checkered last"></i>
                                </span>
                                <span>
                                    <i className="fa-solid fa-flag-checkered first"></i>
                                    Départ à 10h00
                                    <i className="fa-solid fa-flag-checkered last"></i>
                                </span>
                                <a
                                    href="../assets/img/parcours/La Delanchy 2026 prefec.pdf"
                                    target="_blank"
                                    download="La Delanchy 2026 prefec.pdf"
                                >
                                    <button className="btn-race">
                                        Télécharger le tracé
                                    </button>
                                </a>
                            </li>

                            <li className="custom-li">
                                <span>
                                    <i className="fa-solid fa-flag-checkered first"></i>
                                    Départ à 10h05
                                    <i className="fa-solid fa-flag-checkered last"></i>
                                </span>
                                7 km libre (12€)
                                 <a
                                    href="../assets/img/parcours/Marche nordique 7Km libre.pdf"
                                    target="_blank"
                                    download="Marche nordique 7Km libre.pdf"
                                >
                                    <button className="btn-race">
                                        Télécharger le tracé
                                    </button>
                                </a>
                            </li>
                        </ul>
                        <div className="warning">
                            <div className="wild">
                                <i className="fa-solid fa-triangle-exclamation custom"></i>
                                <p>Pas de gobelets aux ravitaillements</p>
                                <i className="fa-solid fa-triangle-exclamation custom"></i>
                            </div>
                            <p>Prévoir vos écotasses.</p>
                        </div>
                        <em>
                            * Licence FFA ou attestation PPS obligatoire
                            (uniquement pour le 18km).
                        </em>
                    </div>
                </section>

                <section className="container-section program">
                    <div
                        className="children-left"
                        data-aos="fade-right"
                        data-aos-offset="200"
                    >
                        <img
                            className="children-picture"
                            src="../assets/img/enfant-course.jpg"
                            alt="enfants lors du trail-muco"
                        />
                    </div>
                    <div
                        className="children-right"
                        data-aos="fade-left"
                        data-aos-offset="200"
                    >
                        <h2>Courses Enfants</h2>
                        <strong>
                            Départ de la base de loisirs de Haute Vilaine - à St
                            M'Hervé (35)
                        </strong>
                        <br />
                        <h4>Inscription sur place uniquement</h4>

                        <em>Premier départ à partir de 10h45.</em>
                        <ul>
                            <li className="custom-li">
                                800m (de 7 à 9 ans)
                                <br />
                                <i className="fa-solid fa-flag-checkered first"></i>{' '}
                                Départ à 10h15{' '}
                                <i className="fa-solid fa-flag-checkered last"></i>
                            </li>
                            <li className="custom-li">
                                2000m (de 10 à 11 ans)
                                <br />
                                <i className="fa-solid fa-flag-checkered first "></i>{' '}
                                Départ à 10h30{' '}
                                <i className="fa-solid fa-flag-checkered last "></i>
                            </li>
                            <li className="custom-li">
                                3000m (de 12 à 16 ans)
                                <br />
                                <i className="fa-solid fa-flag-checkered first"></i>{' '}
                                Départ à 10h45{' '}
                                <i className="fa-solid fa-flag-checkered last"></i>
                            </li>
                        </ul>
                        <a
                            href="../assets/documents/Flyer enfant 2026.png"
                            target="_blank"
                            download="Flyer enfant 2026.png"
                        >
                            <button className="btn-race">
                                Télécharger le coupon
                            </button>
                        </a>

                        <em>
                            *Attestation d'accord parental obligatoire.<br></br>
                            Un coupon par enfant.
                        </em>
                    </div>
                </section>
                <section className="container-section program">
                    <div
                        className="children-left"
                        data-aos="fade-right"
                        data-aos-offset="200"
                    >
                        <img
                            className="children-picture"
                            src="../assets/img/trail-adult.jpg"
                            alt="course adulte lors du trail-muco"
                        />
                    </div>
                    <div
                        className="children-right"
                        data-aos="fade-left"
                        data-aos-offset="200"
                    >
                        <h2>Trails Adultes</h2>
                        <strong>
                            Départ de la base de loisirs de Haute Vilaine - à St
                            M'Hervé (35)
                        </strong>
                        <br />
                        <ul>
                            <li className="custom-li">
                                30km (14€)
                                <br />
                                <i className="fa-solid fa-flag-checkered first"></i>{' '}
                                Départ à 13h30{' '}
                                <i className="fa-solid fa-flag-checkered last"></i>
                                <a
                                    href="../assets/img/parcours/Tracé 30KM  muco 2026 v1.pdf"
                                    target="_blank"
                                    download="Tracé 30KM  muco 2026 v1.pdf"
                                >
                                    <button className="btn-race">
                                        Télécharger le tracé
                                    </button>
                                </a>
                            </li>
                            <li className="custom-li">
                                La Groupama 21km (14€)
                                <br />
                                <i className="fa-solid fa-flag-checkered first"></i>{' '}
                                Départ à 14h00{' '}
                                <i className="fa-solid fa-flag-checkered last"></i>
                                <a
                                    href="../assets/img/parcours/Tracé 21KM  muco 2026 v1.pdf"
                                    target="_blank"
                                    download="Tracé 21KM  muco 2026 v1.pdf"
                                >
                                    <button className="btn-race">
                                        Télécharger le tracé
                                    </button>
                                </a>
                            </li>
                            <li className="custom-li">
                                La Pigeon 11km (14€)
                                <br />
                                <i className="fa-solid fa-flag-checkered first"></i>{' '}
                                Départ à 15h00{' '}
                                <i className="fa-solid fa-flag-checkered last"></i>
                                <a
                                    href="../assets/img/parcours/Tracé 11KM  muco 2026 v1.pdf"
                                    target="_blank"
                                    download="Tracé 11KM  muco 2026 v1.pdf"
                                >
                                    <button className="btn-race">
                                        Télécharger le tracé
                                    </button>
                                </a>
                            </li>
                        </ul>
                        <div className="warning">
                            <div className="wild">
                                <i class="fa-solid fa-triangle-exclamation custom"></i>
                                <p>Pas de gobelets aux ravitaillements</p>
                                <i class="fa-solid fa-triangle-exclamation custom"></i>
                            </div>
                            <p>Prévoir vos écotasses.</p>
                        </div>
                        <em>
                            * Attestation Parcours Prévention Santé obligatoire.
                            <br></br>
                            Voir article 4 du règlement.
                        </em>
                    </div>
                </section>
                <section className="container-section program">
                    <div
                        className="children-left"
                        data-aos="fade-right"
                        data-aos-offset="200"
                    >
                        <img
                            className="children-picture"
                            src="../assets/img/rando.jpg"
                            alt="Randonnée lors du trail muco"
                        />
                    </div>
                    <div
                        className="children-right"
                        data-aos="fade-left"
                        data-aos-offset="200"
                    >
                        <h2>Les Randos</h2>
                        <strong>
                            Départ de la base de loisirs de Haute Vilaine - à St
                            M'Hervé (35)
                        </strong>

                        <ul className="nocturne-list">
                            <li className="">
                                8km - Vitré Accueil (8€)
                                <br />
                                <i className="fa-solid fa-flag-checkered first"></i>{' '}
                                Départ: 14h05{' '}
                                <i className="fa-solid fa-flag-checkered last"></i>
                                <a
                                    href="../assets/img/parcours/Rando office de tourisme Vitré  8Km8.pdf"
                                    target="_blank"
                                    download="Rando office de tourisme Vitré  8Km8.pdf"
                                >
                                    <button className="btn-race">
                                        Télécharger le tracé
                                    </button>
                                </a>
                            </li>
                            <li className="">
                                <p>9km - L' OTSI (8€)</p>
                                <p>
                                    <i className="fa-solid fa-flag-checkered first"></i>
                                    Départ: 13h35
                                    <i className="fa-solid fa-flag-checkered last"></i>
                                </p>
                                 <a
                                    href="../assets/img/parcours/Rando L'Otsi  9Km5.pdf"
                                    target="_blank"
                                    download="Rando L'Otsi  9Km5.pdf"
                                >
                                    <button className="btn-race">
                                        Télécharger le tracé
                                    </button>
                                </a>
                            </li>
                        </ul>
                        <div className="warning">
                            <div className="wild">
                                <i class="fa-solid fa-triangle-exclamation custom"></i>
                                <p>Pas de gobelets aux ravitaillements</p>
                                <i class="fa-solid fa-triangle-exclamation custom"></i>
                            </div>
                            <p>Prévoir vos écotasses.</p>
                        </div>
                        <div className="groupamaMaladieRare">
                            <a
                                href="https://www.fondation-groupama.com/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src="../assets/img/sponsors/GroupamaMaladiesRare.jpg"
                                    alt=""
                                />
                            </a>
                        </div>
                        <em>* Inscriptions uniquement sur place.</em>
                        <br />
                        <em>* Tarif réduit 4 euros pour les - 16 ans.</em>
                    </div>
                </section>
                <h3>Vendredi 2 octobre et samedi 3 octobre 2026</h3>
                <section className="container-section program end">
                    <div
                        className="children-left"
                        data-aos="fade-right"
                        data-aos-offset="200"
                    >
                        <img
                            className="children-picture"
                            src="../assets/img/défi-planchais.jpg"
                            alt="médailles-récompenses"
                        />
                    </div>
                    <div
                        className="children-right"
                        data-aos="fade-left"
                        data-aos-offset="200"
                    >
                        <h2>Défis</h2>
                        <strong>
                            Départ de la base de loisirs de Haute Vilaine - à St
                            M'Hervé (35)
                        </strong>

                        <ul className="nocturne-list">
                            <li className="custom-li">
                              Défi Planchais 32km (22€)
                                <br />                           
                            </li>
                             <li className="custom-li">
                              Défi Tourneux 16km (20€)
                                <br />
                                <i className="fa-solid fa-flag-checkered first"></i>{' '}
                                Classement et récompenses par cumul de la Cap'Tambule 5 km et du trail 11km
                                <i className="fa-solid fa-flag-checkered last"></i>
                                <br />                               
                            </li>
                        </ul>
                        <em>
                            * Classement et récompenses par cumul de la
                            Cap'Tambule 12km et du trail de 22km.
                        </em>
                        <div className="warning">
                            <div className="wild">
                                <i class="fa-solid fa-triangle-exclamation custom"></i>
                                <p>Pas de gobelets aux ravitaillements</p>
                                <i class="fa-solid fa-triangle-exclamation custom"></i>
                            </div>
                            <p>Prévoir vos écotasses.</p>
                        </div>
                    </div>
                </section>
                {/* <section className="container-section program end">
                    <div
                        className="children-left"
                        data-aos="fade-right"
                        data-aos-offset="200"
                    >
                        <img
                            className="children-picture"
                            src="../assets/img/repas.jpg"
                            alt="repas assiette charcuteries"
                        />
                    </div>
                    <div
                        className="children-right"
                        data-aos="fade-left"
                        data-aos-offset="200"
                    >
                        <h2>
                            <i className="fa-solid fa-utensils first"></i> Repas
                            du samedi soir (07/10){' '}
                            <i className="fa-solid fa-utensils last"></i>
                        </h2>
                        <strong>
                            Repas en salle à Bourgon à 20h00 (17€)
                            <br />
                            Ou
                            <br />À emporter, de 18h à 19h à la salle de la
                            Chapelle-Erbrée (16€)
                        </strong>

                        <ul className="nocturne-list">
                            <li className="custom-li">
                                Règlement par chèque ou espèces.
                                <br />
                                Inscription de préférence par téléphone au
                                06.79.76.17.61.
                            </li>
                        </ul>
                        <a
                            href="../assets/documents/Bulletin inscription repas.jpg"
                            target="_blank"
                            download="Bulletin inscription repas.jpg"
                        >
                            <button className="btn-race">
                                Télécharger le coupon d'inscription
                            </button>
                        </a>
                        <em>* Chèque à l'ordre de VLM Virade de Vitré.</em>
                    </div>
                </section> */}
            </div>
            <Footer />
            <Sponsors />
        </div>
    );
};

export default Program;
